import { render, staticRenderFns } from "./TransformationDetails.vue?vue&type=template&id=5e0097b2&"
import script from "./TransformationDetails.vue?vue&type=script&lang=ts&"
export * from "./TransformationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports